export default __webpack_public_path__ + "static/media/yellowflowers.8f3dcce6.png";